/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'hub': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M30.63 15.25a8.4 8.4 0 0 0 5.97 2.48c4.64 0 8.4-3.75 8.4-8.37A8.38 8.38 0 0 0 36.6 1a8.38 8.38 0 0 0-8.09 10.64L17.37 18.1a8.4 8.4 0 0 0-5.97-2.47A8.38 8.38 0 0 0 3 24a8.38 8.38 0 0 0 8.4 8.36 8.4 8.4 0 0 0 5.97-2.48l11.15 6.47A8.38 8.38 0 0 0 36.6 47c4.64 0 8.4-3.74 8.4-8.36a8.38 8.38 0 0 0-8.4-8.37 8.4 8.4 0 0 0-5.96 2.47l-11.15-6.47a8.33 8.33 0 0 0 0-4.54l11.14-6.48zM36.6 5.18a4.2 4.2 0 1 0-.02 8.38 4.2 4.2 0 0 0 .02-8.38zM14.97 21.8a2.2 2.2 0 0 0 .12.2 4.15 4.15 0 0 1-.12 4.2A4.2 4.2 0 0 1 7.2 24a4.2 4.2 0 0 1 7.77-2.2zM32.4 38.64c0-.68.16-1.33.45-1.9a2.12 2.12 0 0 0 .26-.43 4.2 4.2 0 0 1 7.69 2.33 4.2 4.2 0 0 1-8.4 0z"/>'
  }
})
